import { forwardRef } from "react";
import { classNames } from "zeta-dom-react";

import { ReactComponent as IconArrowRight } from "src/assets/icons/arrowRight.svg";
import { ReactComponent as IconArrowRight2 } from "src/assets/icons/arrowRight2.svg";
import { ReactComponent as IconArrowLeft } from "src/assets/icons/arrowLeft.svg";
import { ReactComponent as IconClose } from "src/assets/icons/close.svg";
import { ReactComponent as IconGlobe } from "src/assets/icons/globe.svg";
import { ReactComponent as IconHide } from "src/assets/icons/hide.svg";
import { ReactComponent as IconLock } from "src/assets/icons/lock.svg";
import { ReactComponent as IconShow } from "src/assets/icons/show.svg";
import { ReactComponent as IconWarning } from "src/assets/icons/warning.svg";
import { ReactComponent as IconWarningFilled } from "src/assets/icons/warning-filled.svg";
import { ReactComponent as IconNotificationOn } from "src/assets/icons/notification-on.svg";
import { ReactComponent as IconNotification } from "src/assets/icons/notification.svg";
import { ReactComponent as IconReport } from "src/assets/icons/report.svg";
import { ReactComponent as IconSearch } from "src/assets/icons/search.svg";
import { ReactComponent as IconMail } from "src/assets/icons/mail.svg";
import { ReactComponent as IconWifi } from "src/assets/icons/wifi.svg";
import { ReactComponent as IconPhone } from "src/assets/icons/phone.svg";
import { ReactComponent as IconRemove } from "src/assets/icons/remove.svg";
import { ReactComponent as IconPin } from "src/assets/icons/pin.svg";
import { ReactComponent as IconPinOutline } from "src/assets/icons/pin-outline.svg";
import { ReactComponent as IconClipboard } from "src/assets/icons/clipboard.svg";
import { ReactComponent as IconLink } from "src/assets/icons/link.svg";
import { ReactComponent as IconInquiry } from "src/assets/icons/inquiry.svg";
import { ReactComponent as IconRefresh } from "src/assets/icons/refresh.svg";
import { ReactComponent as IconLogout } from "src/assets/icons/logout.svg";
import { ReactComponent as IconSettings } from "src/assets/icons/settings.svg";
import { ReactComponent as IconDrag } from "src/assets/icons/drag.svg";
import { ReactComponent as IconMenu } from "src/assets/icons/menu.svg";
import { ReactComponent as IconMenuRed } from "src/assets/icons/menu-red.svg";
import { ReactComponent as IconLinkClip } from "src/assets/icons/linkClip.svg";
import { ReactComponent as Download } from "src/assets/icons/download.svg";
import { ReactComponent as Note } from "src/assets/icons/note.svg";
import { ReactComponent as IconCalendar } from "src/assets/icons/calendar.svg";
import { ReactComponent as IconSuccess } from "src/assets/icons/success.svg";
import { ReactComponent as IconFailure } from "src/assets/icons/failure.svg";
import { ReactComponent as IconInfo } from "src/assets/icons/info.svg";
import { ReactComponent as IconInfoFilled } from "src/assets/icons/info-filled.svg";
import { ReactComponent as IconDots } from "src/assets/icons/dots.svg";
import { ReactComponent as IconSuccessFilled } from "src/assets/icons/success-filled.svg";
import { ReactComponent as IconCustomer } from "src/assets/icons/customer.svg";
import { ReactComponent as IconOpenNew } from "src/assets/icons/open-new.svg";
import { ReactComponent as IconBlock } from "src/assets/icons/block.svg";
import { ReactComponent as IconFilter } from "src/assets/icons/filter.svg";
import { ReactComponent as IconEdit } from "src/assets/icons/edit.svg";
import { ReactComponent as IconMoneyExchange } from "src/assets/icons/moneyExchange.svg";
import { ReactComponent as IconCheckMark } from "src/assets/icons/checkMark.svg";
import { ReactComponent as IconInquiryDialogBox } from "src/assets/icons/inquiryDialogBox.svg";
import { ReactComponent as IconRemoveFilled } from "src/assets/icons/removeFilled.svg";

export type IconNames = keyof typeof components;

export interface IconProps extends Pick<React.ComponentPropsWithRef<'i'>, 'onClick' | 'onMouseOver' | 'onMouseOut'> {
    icon: IconNames;
    className?: string;
    disabled?: boolean;
}

const components = {
    arrowRight: IconArrowRight,
    arrowRight2: IconArrowRight2,
    arrowLeft: IconArrowLeft,
    close: IconClose,
    globe: IconGlobe,
    hide: IconHide,
    lock: IconLock,
    show: IconShow,
    warning: IconWarning,
    warningFilled: IconWarningFilled,
    notificationOn: IconNotificationOn,
    notification: IconNotification,
    report: IconReport,
    search: IconSearch,
    mail: IconMail,
    wifi: IconWifi,
    phone: IconPhone,
    remove: IconRemove,
    pin: IconPin,
    pinOutline: IconPinOutline,
    clipboard: IconClipboard,
    link: IconLink,
    inquiry: IconInquiry,
    refresh: IconRefresh,
    logout: IconLogout,
    settings: IconSettings,
    drag: IconDrag,
    menu: IconMenu,
    menuRed: IconMenuRed,
    linkClip: IconLinkClip,
    download: Download,
    note: Note,
    calendar: IconCalendar,
    success: IconSuccess,
    failure: IconFailure,
    info: IconInfo,
    infoFilled: IconInfoFilled,
    dots: IconDots,
    successFilled: IconSuccessFilled,
    customer: IconCustomer,
    openNew: IconOpenNew,
    block: IconBlock,
    filter: IconFilter,
    edit: IconEdit,
    moneyExchange: IconMoneyExchange,
    checkMark: IconCheckMark,
    inquiryDialogBox: IconInquiryDialogBox,
    removeFilled: IconRemoveFilled,
};

export const Icon = forwardRef<HTMLElement, IconProps>((props, ref) => {
    const { icon, ..._props } = props;
    const Icon1 = components[icon];
    return <i {..._props} ref={ref} className={classNames('eac-icon', props.className, { disabled: props.disabled })}>{Icon1 && <Icon1 />}</i>;
});
